import React, { createRef } from 'react';
import { renderReport } from '../components/elementList';
import StepManager from '../components/stepManager';
import UiFieldEntity from './uiFieldEntity';
import UiGetField from './uiGetField';

let documentation = {
    title: 'Add Field Entity',
    brief: 'Adds one entity-view per customer type Thingsboard Acuadori',
    content: <p>Each EntityView created (per customer-type) will be visualized in the customer's
            Acuadori dashboard. The field <i>Coordinates</i> and field's latitude, longitude attributes will be used by
            the dashboard through its <i>Alias filters</i> on the EntityView. The filters to match are based on the created
            EntityView type, while the EntityView name is used to visualize the field name on the dashboard's widgets.</p>,

    steps: [
        {
            id: 0, 
            title: 'Select Field',
            brief: 'Creates one entityView of the chosen field for each chosen customer-type.',
            content: 'The chosen field name and the customer types are used to build each EntityView name and type.'
        }
    ]
};

class UiAddFieldEntity extends React.Component {

    static defaultProps = {
        FIELDTYPE: 'acuadori field',
        customer: {}
    };

    constructor(props) {
        super(props);

        this.fieldService = props.services.asset;
        this.customerService = props.services.customer;

        this.stepManagerRef = createRef();

        this.state = {
            field: null,
            fieldEntities: [],
            stepList: this.makeSteps()
        };
    }

    documentation = () => { return documentation; }

    makeSteps = () => {
        let { instances } = this.props.customer;

        let steps = [
            {
                stepId: 0, stepName: this.documentation().steps[0].title,
                formValue: this.renderGetField, dataValue: () => renderReport(this.reportField()),
                documentation: this.documentation().steps[0]
            },
        ];
        instances.forEach((item, index) => {
            let step = {
                stepId: index + 1,
                stepName: `Connect ${item.name} Field to Customer`,
                formValue: () => this.renderFieldEntity(item),
                documentation: {
                    id: index + 1, 
                    title: 'Select Field',
                    brief: 'Connects a field-view to selected Customer',
                }
            };
            steps.push(step);
        });
        return steps;
    };

    stepManagerAdvance = () => {
        const element = this.stepManagerRef.current;
        element.advance(() => {
            if (element.isEnd()) {
                this.props.finished(this.state.field, this.reportAllComponentData());
            }
        });
    };

    reportField = () => {
        let { field } = this.state;
        if (!field) {
            return null;
        }
        let data = [
            { key: 'ID', value: field.id.id },
            { key: 'NAME', value: field.name },
            { key: 'TYPE', value: field.type }
        ];
        return data;
    };

    reportAllComponentData = () => {
        let { fieldEntities } = this.state;
        let data = [];
        this.reportField().forEach(value => data.push(value));
        for (let i = 0; i < fieldEntities.length; i++) {
            fieldEntities[i].report.forEach(value => data.push(value))
        }
        return data.length > 0 ? data : null;
    };

    handleValidate = (values) => {
        const errors = {};
        if (!values.name) {
            errors.name = 'Required';
        }
        return errors;
    };

    handleSubmitError = (error) => {
        let message = 'Error: ' + error.message;
        this.renderAlert(message, 'warning');
    };

    renderGetField = () => {
        return (
            <div>
                <UiGetField
                    services={{
                        field: this.props.services.asset
                    }}
                    finished={(fieldData) => {
                        this.setState({ field: fieldData });
                        this.stepManagerAdvance();
                    }}
                />
            </div>
        );
    };

    renderFieldEntity = (customer) => {
        let { field } = this.state;

        field = { ...field, name: `${field.name} ${customer.name}` };

        return (
            <UiFieldEntity
                finished={(fieldEntityData, report) => {
                    let { fieldEntities } = this.state;
                    fieldEntities.push({ data: fieldEntityData, report: report });
                    this.setState({ fieldEntities: fieldEntities });
                    this.stepManagerAdvance();
                }}
                error={this.handleSubmitError}
                services={{ asset: this.fieldService, customer: this.customerService }}
                customer={{ name: customer.name, id: customer.id }}
                field={field}
                type={{ name: customer.type.name, fixedPre: customer.type.fieldPre, fixedPost: customer.type.fieldPost, fixedNamePost: customer.name }}
            />
        );
    };

    renderAlert = (message, variant) => {
        this.stepManagerRef.current.showAlert(message, variant);
    };

    render() {
        let { stepList } = this.state;
        let { title } = this.props;
        return (
            <div className="container">
                <StepManager ref={this.stepManagerRef}
                    alert={{ active: true }}
                    progressBar={{ active: true }}

                    startStepId={0} endStepId={stepList.length - 1}

                    onFinished={() => {
                        //window.open( this.props.links.thingsboardRoutes.dashboards );
                        this.setState({ finished: true })
                    }}

                    stepList={stepList}

                    documentation={{
                        title: title || this.documentation().title,
                        subtitle: 'Adds one entity-view per customer type Thingsboard Acuadori',
                        brief: this.documentation().brief,
                        content: this.documentation().content,
                    }}
                />
            </div>
        );
    }
}

export default UiAddFieldEntity;
export {
    UiAddFieldEntity,
    documentation
}
